import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { CustomControlExample } from '../../components/examples/controls-examples';
import { WithControlsAPI } from '../../components/api';
export const _frontmatter = {
  "Title": "Custom Controls"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "custom-controls"
    }}>{`Custom controls`}</h1>
    <CustomControlExample mdxType="CustomControlExample" />
    <p><em parentName="p">{`A custom control example`}</em></p>
    <p>{`Don't like the predefined control types? Want more control on controls? no problem.`}</p>
    <p>{`You can import `}<inlineCode parentName="p">{`withControls`}</inlineCode>{`, and wrap any arbitrary component with it.`}</p>
    <h2 {...{
      "id": "withcontrols-props"
    }}>{`withControls props`}</h2>
    <p>{`When you do that, you expose this component to the following props:`}</p>
    <WithControlsAPI mdxType="WithControlsAPI" />
    <h2 {...{
      "id": "custom-controls-use-cases"
    }}>{`Custom controls use cases`}</h2>
    <ul>
      <li parentName="ul">{`do your own styling`}</li>
      <li parentName="ul">{`position controls how you see fit relative to the `}<inlineCode parentName="li">{`Frame`}</inlineCode>{` (not just below)`}</li>
      <li parentName="ul">{`combine `}<inlineCode parentName="li">{`Frame`}</inlineCode>{` and `}<inlineCode parentName="li">{`Control`}</inlineCode>{` - the same component can render the simulation and change its parameters.`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {withControls, Model} from 'react-sim';

const MyControl = ({ params, setParams }) => (
  <input
    type="range"
    value={params['my-param']}
    onChange={e => setParams({ 'my-param': Number(e.target.value) })}
  />
);

const CustomControl = withControls(MyControl);

/* ... */

const CustomControlExample = () => (
  <Model showTimer={false} initialParams={{ 'my-param': 50 }}>
    <Flex flexDirection="column">
      <CustomControl />
      <MyFrame />
    </Flex>
  </Model>
`}</code></pre>
    <p>{`The `}<a parentName="p" {...{
        "href": "/react-sim/examples/1d-automata"
      }}>{`1D automata`}</a>{` is an example of custom controls.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      